import { SLRNavItem, getIcon } from "@slr/shared-library";
import { ADMINISTRATION_PATH } from "configs";
import { useIsPlatformAdmin } from "hooks/admin/useIsPlatformAdmin";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import {
  globalNavigationConfig,
  isCurrentUrl,
} from "settings/global-navigation.settings";
import "./GlobalNavigationItems.scss";

export const useGlobalNavigationItems = (): SLRNavItem[] => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isPlatformAdmin = useIsPlatformAdmin();

  return useMemo(() => {
    const items: SLRNavItem[] = [
      {
        to: globalNavigationConfig.start,
        label: t("navigation.start"),
        icon: getIcon("fas", "house"),
        iconActive: getIcon("fas", "house"),
        isActive: isCurrentUrl(globalNavigationConfig.start),
      },
      {
        to: globalNavigationConfig.book,
        label: t("navigation.subdomains.book"),
        icon: getIcon("fas", "calendar-days"),
        iconActive: getIcon("fas", "calendar-days"),
        isActive: isCurrentUrl(globalNavigationConfig.book),
      },
      {
        to: globalNavigationConfig.rent,
        label: t("navigation.subdomains.rent"),
        icon: getIcon("fas", "key"),
        iconActive: getIcon("fas", "key"),
        isActive: isCurrentUrl(globalNavigationConfig.rent),
      },
      {
        to: globalNavigationConfig.about,
        label: t("navigation.subdomains.about"),
        icon: getIcon("fas", "circle-info"),
        iconActive: getIcon("fas", "circle-info"),
        isActive: isCurrentUrl(globalNavigationConfig.about),
      },
    ];

    if (isPlatformAdmin) {
      items.push({
        to: ADMINISTRATION_PATH,
        label: t("navigation.subdomains.administration"),
        icon: getIcon("fas", "users-gear"),
        iconActive: getIcon("fas", "users-gear"),
        isActive: pathname.startsWith(ADMINISTRATION_PATH),
      });
    }

    return items;
  }, [t, isPlatformAdmin, pathname]);
};

export default useGlobalNavigationItems;
